import React, { useState } from 'react';
import { v4 as uuidv4 } from 'uuid';

import {
	Card
} from '@bosch/bt-ui';

import './AddCompanyPage.css';
import withErrorHandler from '../../../components/ErrorHandler';
import { useParams } from 'react-router-dom';
import PostCompanyForm from '../SettingsComponent/PostCompanyForm';
import RestfulCallout from '../../../components/RestfulCallout';

const AddCompanyPage = (props) => {
	const {
		token,
		setIsDirty
	} = props;

	const {
		sapCompanyId = '',
		sapSalesRegion = 'us',
		companyName = '',
		deviceRegion = ''
	} = useParams();
	const [isOperationDone, setOperationDone] = useState(false);
	const createDate = new Date().toJSON();

	const rpsControlSettings = {
		useCiam: true,
		allowUploadofPanelInfo: true,
		useConnectorService: true,
		allowCBSAuthforClouldPanelConnections: true,
		onlineServiceKey: uuidv4(),
		createDate: createDate,
		updateDate: createDate
	}

	const mobilenetworksSettings = {
		networkModel: '',
		networkModelDescription: '',
		networkModelName: '',
		vpnEndpoint: 'vpn-2.onmagneto.com',
		createDate: createDate,
		updateDate: createDate
	}

	const companySubnetsSettings = {
		cidr: 0,
		domainIp: '',
		subnetId: '',
		createDate: createDate,
		updateDate: createDate
	}

	const companySettings = {
		mnvOsInUse: ['Aeris', 'Wyless', 'Verizon'],
		servicePortalOnboarded: true,
		makeRemotePortalReadOnly: true,
		createDate: createDate,
		updateDate: createDate
	}

	const companyInfo = {
		companyName: companyName,
		sapSalesRegion: sapSalesRegion,
		sapCompanyId: sapCompanyId,
		deviceRegion: deviceRegion,
		createDate: createDate,
		updateDate: createDate
	}

	const companyMobileAlertSettings = {
		sapCompanyId: '',
		usageMonitoringEnabled: false,
		alertThresholdPercent:100,
		warningThresholdPercent: 75,
		alertMethodology:'OnceADay',
		usageAlertEmail:'',
		preferredLanguage: 'en-US',
		DeliveryTypes:  ['Email'],
		createDate: createDate,
		updateDate: createDate
	}

	const result = {
		'companySettings': companySettings,
		'rpsControlSettings': rpsControlSettings,
		'companyInfo': companyInfo,
		'networkModelSettings': mobilenetworksSettings,
		'companySubnets': companySubnetsSettings,
		'companyMobileAlertSettings': companyMobileAlertSettings
	}
	const handleSaveSuccess = () => {
        setOperationDone(true);
    };
	return (
		<Card
			background="secondary"
			htmlAttributes={{
				id: 'add-company-page',
				className: 'page'
			}}
		>
			<div className="page-contents">
				<PostCompanyForm token={token} onSuccess={handleSaveSuccess} setIsDirty={setIsDirty} result={result} mode={(sapCompanyId.trim().length === 0) ? 'add' : 'reservation'} />
				{isOperationDone && (
                    <RestfulCallout
                        status="success"
                        returnObj={{ status: 'Success', message: 'Operation Done.' }}
                    />
                )}
			</div>
		</Card>
	);
};

export default withErrorHandler(React.memo(AddCompanyPage));